module.exports = __webpack_public_path__ + "img/experience09.e6a466ac.jpg";